"use client";

// app/blog/_components/CategoryPills.tsx
// Sticky scrollable category bar. Currently routes via Next router
// to /blog or /blog/category/<slug>.

import { useRouter, usePathname } from "next/navigation";
import { useState } from "react";
import type { CategoryMeta } from "../_data/types";

interface Props {
  categories: CategoryMeta[];
  /** Currently-selected category slug, or undefined for "all". */
  active?: string;
  /** Total post count shown next to "All articles". */
  totalCount: number;
}

export function CategoryPills({ categories, active, totalCount }: Props) {
  const router = useRouter();
  const pathname = usePathname();
  const [selected, setSelected] = useState<string | undefined>(active);

  const go = (slug: string | undefined) => {
    setSelected(slug);
    router.push(slug ? `/blog/category/${slug}` : "/blog");
  };

  const isActive = (slug: string | undefined) => {
    if (!slug) return !active && pathname === "/blog";
    return active === slug;
  };

  return (
    <nav className="lx-cat-bar" aria-label="Article categories">
      <div className="lx-cat-inner">
        <button
          type="button"
          className={`lx-pill${isActive(undefined) ? " active" : ""}`}
          onClick={() => go(undefined)}
        >
          All articles<span className="count">{totalCount}</span>
        </button>
        {categories.map((c) => (
          <button
            key={c.slug}
            type="button"
            className={`lx-pill${isActive(c.slug) ? " active" : ""}`}
            onClick={() => go(c.slug)}
          >
            {c.label}
            {typeof c.count === "number" && <span className="count">{c.count}</span>}
          </button>
        ))}
      </div>
    </nav>
  );
}
